import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface SettingsAction {
    action: 'save' | 'reset';
}

@Injectable({
    providedIn: 'root',
})
export class SettingPanelService {
    private actionSubject = new Subject<SettingsAction>();
    public action$ = this.actionSubject.asObservable();

    private refreshSubject = new Subject<void>();
    public refresh$ = this.refreshSubject.asObservable();

    private saveLoadingSubject = new BehaviorSubject<boolean>(false);
    public saveLoading$ = this.saveLoadingSubject.asObservable();

    private resetLoadingSubject = new BehaviorSubject<boolean>(false);
    public resetLoading$ = this.resetLoadingSubject.asObservable();

    constructor() {}

    /**
     * Emit save action for the specified grid
     */
    saveSettings(): void {
        this.actionSubject.next({ action: 'save' });
    }

    /**
     * Emit reset action for the specified grid
     */
    resetSettings(): void {
        this.actionSubject.next({ action: 'reset' });
    }

    triggerRefresh(): void {
        this.refreshSubject.next();
    }

    setSaveLoading(loading: boolean): void {
    this.saveLoadingSubject.next(loading);
  }

  setResetLoading(loading: boolean): void {
    this.resetLoadingSubject.next(loading);
  }
}
